// extracted by mini-css-extract-plugin
export default {"card":"StatusCard_card__48t5m"};